import React from 'react';
import classes from './FacebookLinkPreviewCard.module.scss';
import { Maybe, OpenGraph } from '../../../../models/graphql';
import classNames from 'classnames';
import { ReactComponent as NoImage } from '../../../../assets/images/no-image-130.svg';

// The utility type to make nullable types non-nullable.
type NonNullableProperties<T> = {
  [K in keyof T]: T[K] extends Maybe<infer U> ? U : T[K];
};
type NonNullableAndRequiredFacebookLinkPreview = Required<NonNullableProperties<OpenGraph>>;

export type FacebookLinkPreviewCardViewProps = NonNullableAndRequiredFacebookLinkPreview & {
  link: string | null;
  size: 'large' | 'small';
  /*
  TODO: We need to get image width / height in order to calculate the layout type.
  Currently we only show the large, since we don't know the image size
  */
};

export const FacebookLinkPreviewCardView = (props: FacebookLinkPreviewCardViewProps): JSX.Element => {
  const { description, image, title, link, size } = props;
  switch (size) {
    case 'large':
      return (
        <div className={classNames(classes.FacebookCard)}>
          <div className={'grid-y'}>
            {image ? (
              <div className={classNames('cell')}>
                <div className={classes.ImageWrapperLarge}>
                  <img alt={title ?? 'default image'} src={image} className={classNames(classes.Image)} />
                </div>
              </div>
            ) : null}
            <div className={classNames('cell', 'auto')}>
              <div className={classNames(classes.TextWrapperLarge, 'grid-y', 'align-center')}>
                {link ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.LinkTitle, classes.LinkTitleLarge)}>
                      {link.replace(/(^\w+:|^)\/\/(www\.)?/, '')}
                    </div>
                  </div>
                ) : null}
                {title ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.Title, classes.TitleLarge)}>{title}</div>
                  </div>
                ) : null}
                {description ? (
                  <div className={'grid-x'}>
                    <div
                      className={classNames(
                        classes.Description,
                        classes.DescriptionLarge,
                        title ? classes.DescriptionLargeWithTitle : classes.DescriptionLargeNoTitle
                      )}>
                      {description}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );
    default:
      return (
        <div className={classNames(classes.FacebookCard)}>
          <div className={'grid-x'}>
            <div className={classNames('cell', classes.ImageWrapperSmall)}>
              {image ? (
                <img
                  alt={title ?? 'no image'}
                  src={image}
                  className={classNames(classes.Image, classes.ImageSummary)}
                />
              ) : (
                <NoImage />
              )}
            </div>
            <div className={classNames('cell', 'auto')}>
              <div className={classNames(classes.TextWrapperSmall, 'grid-y', 'align-center')}>
                {link ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.LinkTitle, classes.LinkTitleSmall)}>
                      {link.replace(/(^\w+:|^)\/\/(www\.)?/, '')}
                    </div>
                  </div>
                ) : null}
                {title ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.Title, classes.TitleSmall)}>{title}</div>
                  </div>
                ) : null}
                {description ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.Description, classes.DescriptionSmall)}>{description}</div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );
  }
};
